module.exports = __webpack_public_path__ + "img/i_es_plus.66de8a64.svg";